import React from 'react';
import { inr, formatDate } from '../utils/projectFormatters';

/**
 * Column definitions for the project transaction history table.
 */
export const TRANSACTION_HISTORY_COLUMNS = [
  {
    header: 'Type',
    minWidth: '100px',
    accessor: (tx) => {
      const isCredit = tx.kind === 'credit';
      return (
        <span className={`text-[10px] font-black uppercase tracking-tighter ${isCredit ? 'text-emerald-600' : 'text-rose-600'}`}>
          {isCredit ? 'RECEIVED' : 'EXPENSE'}
        </span>
      );
    }
  },
  {
    header: 'To Whom',
    minWidth: '130px',
    accessor: (tx) => <span className="text-[12px] font-medium text-slate-700">{tx.recipient || tx.expenseToWhom || '—'}</span>
  },
  {
    header: 'Category / Type',
    minWidth: '150px',
    accessor: (tx) => {
      const hasSubAmounts = tx.epAmount > 0 || tx.nonStandardAmount > 0 || tx.othersAmount > 0;
      return (
        <div className="flex flex-col">
          <span className="text-[12px] font-medium text-slate-700">
            {tx.kind === 'credit' ? (tx.paymentType || '—') : (tx.expenseCategory || '—')}
          </span>
          {tx.kind === 'expense' && hasSubAmounts && (
            <div className="flex flex-col gap-0.5 mt-0.5 text-[10px] text-slate-400 font-bold tracking-tight">
              {tx.epAmount > 0 && <span className="text-blue-500">EP: {inr(tx.epAmount)}</span>}
              {tx.nonStandardAmount > 0 && <span className="text-amber-500">Non-Std: {inr(tx.nonStandardAmount)}</span>}
              {tx.othersAmount > 0 && <span className="text-slate-500">Others: {inr(tx.othersAmount)}</span>}
            </div>
          )}
        </div>
      );
    }
  },
  {
    header: 'Recipient',
    minWidth: '130px',
    accessor: (tx) => <span className="text-[12px] font-medium text-slate-700">{tx.recipient || '—'}</span>
  },
  {
    header: 'Date',
    minWidth: '110px',
    accessor: (tx) => <span className="text-[12px] font-medium tracking-tight text-slate-500">{formatDate(tx.transactionDate || tx.createdAt)}</span>
  },
  {
    header: 'Amount',
    minWidth: '120px',
    accessor: (tx) => {
      const isCredit = tx.kind === 'credit';
      return (
        <span className={`text-[12px] font-medium tracking-tight tabular-nums ${isCredit ? 'text-emerald-700' : 'text-rose-700'}`}>
          {inr(tx.amount)}
        </span>
      );
    }
  },
  {
    header: 'Method',
    minWidth: '100px',
    accessor: (tx) => (
      <span className="text-[10px] font-black text-slate-500 uppercase">
        {tx.paymentMethod?.replace('_', ' ') || '—'}
      </span>
    )
  },
  {
    header: 'TRX / Ref ID',
    minWidth: '120px',
    accessor: (tx) => <span className="text-[12px] font-medium tracking-tight text-blue-400 tabular-nums">{tx.refId || '—'}</span>
  },
  {
    header: 'Bank / UPI Phone',
    minWidth: '140px',
    accessor: (tx) => (
      <div className="flex flex-col">
        <span className="text-[12px] font-medium text-slate-700">{tx.bankName || '—'}</span>
        {tx.upiPhone && <span className="text-[10px] text-slate-400 font-medium">UPI: {tx.upiPhone}</span>}
      </div>
    )
  },
  {
    header: 'Branch / Receiver',
    minWidth: '130px',
    accessor: (tx) => (
      <div className="flex flex-col">
        <span className="text-[12px] font-medium text-slate-700">{tx.branch || tx.receiverName || '—'}</span>
        {tx.receiverPhone && <span className="text-[10px] text-slate-400 font-medium">Ph: {tx.receiverPhone}</span>}
      </div>
    )
  },
  {
    header: 'Cheque Details',
    minWidth: '140px',
    accessor: (tx) => (
      tx.chequeNumber ? (
        <div className="flex flex-col">
          <span className="text-[11px] font-bold text-slate-700">No: {tx.chequeNumber}</span>
          {tx.chequeDate && <span className="text-[10px] text-slate-400 font-medium">Date: {formatDate(tx.chequeDate)}</span>}
        </div>
      ) : '—'
    )
  },
  {
    header: 'Internal Notes',
    minWidth: '150px',
    accessor: (tx) => {
      const noteText = tx.internalNotes || tx.expenseNotes || '—';
      return (
        <span 
          className="text-[12px] font-medium text-slate-500 truncate block max-w-[200px]" 
          title={noteText}
        >
          {noteText}
        </span>
      );
    }
  }
];
